import { gql } from '@apollo/client';

const SUBMIT_SUPPORT_REQUEST_MUTATION = gql`
  mutation submitSupportRequest($input: SubmitSupportRequestInput!) {
    submitSupportRequest(input: $input) {
      isSuccess
      message
    }
  }
`;

export default SUBMIT_SUPPORT_REQUEST_MUTATION;
